import { Aligner } from "components";
import type { AlignerProps } from "components/Aligner";
import type { ReactStoryblokComponent } from "types/storyblok";

export const AlignerAdapter = ({ blok, sbEditable }: ReactStoryblokComponent<AlignerProps>) => (
  <Aligner {...blok} sbEditable={sbEditable} />
);
